import { type FC, useEffect, useState } from 'react';

interface AnimeOverlayProps {
	show: boolean;
	deactivating: boolean;
}

const OVERLAY_DURATION_MS = 1400;
const TOAST_DURATION_MS = 2200;

export const AnimeOverlay: FC<AnimeOverlayProps> = ({ show, deactivating }) => {
	const [visible, setVisible] = useState(false);
	const [showToast, setShowToast] = useState(false);

	useEffect(() => {
		if (show) {
			setVisible(true);
			// Shake the body
			document.body.classList.add('anime-shake');
			const timer = setTimeout(() => {
				setVisible(false);
				document.body.classList.remove('anime-shake');
			}, OVERLAY_DURATION_MS);

			return () => {
				clearTimeout(timer);
				document.body.classList.remove('anime-shake');
			};
		}
	}, [show]);

	useEffect(() => {
		if (deactivating) {
			setShowToast(true);
			const timer = setTimeout(() => setShowToast(false), TOAST_DURATION_MS);

			return () => clearTimeout(timer);
		}
	}, [deactivating]);

	return (
		<>
			{visible && (
				<div className='anime-overlay' aria-hidden='true'>
					<div className='anime-overlay-lines' />
					<div className='anime-overlay-flash' />
					<div className='anime-overlay-text'>Anime Mode Activated</div>
				</div>
			)}
			{showToast && (
				<div className='anime-deactivate-toast' aria-hidden='true'>
					Normal mode restored
				</div>
			)}
		</>
	);
};
